"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var context_1 = require("./");

var data_1 = require("../data");

exports.initialCouplingContext = {
  couplingScores: new data_1.CouplingContainer()
};
exports.CouplingContext = React.createContext(exports.initialCouplingContext);
exports.CouplingContextConsumer = exports.CouplingContext.Consumer;
/**
 * Shorthand for passing contexts relevant for Coupling Scores - Primarily interaction with residues and secondary structures.
 *
 * @export
 * @extends {React.Component<any, ICouplingContext>}
 */

var CouplingContextProvider =
/** @class */
function (_super) {
  __extends(CouplingContextProvider, _super);

  function CouplingContextProvider(props) {
    var _this = _super.call(this, props) || this;

    _this.state = exports.initialCouplingContext;
    return _this;
  }

  CouplingContextProvider.prototype.render = function () {
    return React.createElement(context_1.SecondaryStructureContextProvider, null, React.createElement(context_1.ResidueContextProvider, null, React.createElement(exports.CouplingContext.Provider, {
      value: this.state
    }, this.props.children)));
  };

  return CouplingContextProvider;
}(React.Component);

exports.CouplingContextProvider = CouplingContextProvider;